import React from 'react';

import { ROUTES } from '@/consts/routes';
import { LogoutOutlined } from '@ant-design/icons';
import { Separator } from '@radix-ui/react-separator';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

interface UserMenuProps {
  handleLogout: () => void;
}

export const UserMenu: React.FC<UserMenuProps> = ({ handleLogout }) => {
  const { t } = useTranslation();

  return (
    <div className="text-typography/85 text-sm font-light">
      <Link
        to={ROUTES.user.terms}
        className="hover:bg-background-400 text-typography/85 block rounded-sm px-3 py-1.5 font-light transition-colors duration-150"
      >
        {t('header.userMenu.terms')}
      </Link>

      <Link
        to={ROUTES.user.privacy}
        className="hover:bg-background-400 text-typography/85 block rounded-sm px-3 py-1.5 font-light transition-colors duration-150"
      >
        {t('header.userMenu.privacy')}
      </Link>

      <Separator orientation="horizontal" className="bg-background-900/10 my-1 h-[1px]" />

      <div
        role="button"
        onClick={handleLogout}
        className="hover:bg-background-400 text-typography/85 flex cursor-pointer items-center rounded-sm px-3 py-1.5 font-light transition-colors duration-150"
      >
        <LogoutOutlined className="mr-1" /> {t('header.userMenu.signOut')}
      </div>
    </div>
  );
};
